import { c as _c } from "react/compiler-runtime";
import AlertComponent, { AlertType } from '@spa/components/alert/alert.component';
import { Fragment, ReactElement, memo, useEffect } from 'react';
import { NamespacedIntl } from '@spa/lib/i18n/common/NamespacedIntl';
import { NewsletterOrigin } from '@spa/generated/graphql/graphql';
import NewsletterRegistrationAlert from '../newsletter-registration-alert.component';
import { NewsletterRegistrationFormStatus } from '@spa/lib/newsletter/newsletterRegistrationStatus';
import NewsletterSubscribeFormComponent from '@spa/components/forms/newsletter-subscribe-form/newsletter-subscribe-form.component';
import { NewsletterSubscribeFormFields } from '@spa/components/forms/newsletter-subscribe-form/newsletterSubscribeFormTypes';
import styles from './newsletter-subscribe.component.module.scss';
import useHoneypotToken from '@spa/components/forms/formik-with-honey/useHoneypotToken';
import useNamespacedIntl from '@spa/lib/i18n/client/hooks/useNamespacedIntl';
import useNewsletterRegistration from '@spa/lib/newsletter/useNewsletterRegistration';
import useNewsletterTracking from '@spa/lib/newsletter/useNewsletterTracking';
export interface Props {
  readonly isActivation: boolean;
  readonly activationSuccessful: boolean;
  readonly hideComponent?: boolean;
}
function NewsletterSubscribeComponent(t0) {
  const $ = _c(22);
  const {
    activationSuccessful,
    isActivation,
    hideComponent: t1
  } = t0;
  const hideComponent = t1 === undefined ? false : t1;
  const honeypotToken = useHoneypotToken();
  const {
    formatMessage
  } = useNamespacedIntl("newsletter");
  const {
    trackNewsletterDoubleOptIn,
    trackNewsletterRegistration
  } = useNewsletterTracking();
  let t2;
  if ($[0] !== formatMessage) {
    t2 = formatMessage("consentText");
    $[0] = formatMessage;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== honeypotToken || $[3] !== t2 || $[4] !== trackNewsletterRegistration) {
    t3 = {
      consent: t2,
      origin: NewsletterOrigin.FORM,
      honeypotToken,
      trackNewsletterRegistration
    };
    $[2] = honeypotToken;
    $[3] = t2;
    $[4] = trackNewsletterRegistration;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const {
    formStatus,
    handleSubmit,
    submissionError
  } = useNewsletterRegistration(t3);
  let t4;
  let t5;
  if ($[6] !== activationSuccessful || $[7] !== isActivation || $[8] !== trackNewsletterDoubleOptIn) {
    t4 = () => {
      if (isActivation && activationSuccessful) {
        trackNewsletterDoubleOptIn();
      }
    };
    t5 = [activationSuccessful, isActivation, trackNewsletterDoubleOptIn];
    $[6] = activationSuccessful;
    $[7] = isActivation;
    $[8] = trackNewsletterDoubleOptIn;
    $[9] = t4;
    $[10] = t5;
  } else {
    t4 = $[9];
    t5 = $[10];
  }
  useEffect(t4, t5);
  let t6;
  if ($[11] !== activationSuccessful || $[12] !== formStatus || $[13] !== formatMessage || $[14] !== handleSubmit || $[15] !== hideComponent || $[16] !== honeypotToken || $[17] !== isActivation || $[18] !== submissionError) {
    t6 = !hideComponent && <div className={styles["newsletter-subscribe"]}><h2>{formatMessage("title")}</h2>{isActivation ? <AlertComponent alertType={activationSuccessful ? AlertType.SUCCESS : AlertType.ERROR} content={formatMessage(activationSuccessful ? "activationSuccess" : "formError")} /> : <Fragment>{formStatus === NewsletterRegistrationFormStatus.SUBMITTED ? <NewsletterRegistrationAlert formatMessage={formatMessage} submissionError={submissionError} /> : <Fragment><span>{formatMessage("subtitle")}</span><NewsletterSubscribeFormComponent handleSubmit={handleSubmit} honeypotToken={honeypotToken} isSubmitting={formStatus === NewsletterRegistrationFormStatus.SUBMITTING} /></Fragment>}</Fragment>}</div>;
    $[11] = activationSuccessful;
    $[12] = formStatus;
    $[13] = formatMessage;
    $[14] = handleSubmit;
    $[15] = hideComponent;
    $[16] = honeypotToken;
    $[17] = isActivation;
    $[18] = submissionError;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== t6) {
    t7 = <>{t6}</>;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
}
export default memo(NewsletterSubscribeComponent);